export default{
    accountLogin: "账号登录",
    iosDownloadIsNotCurrentlySupportedSoStayTuned: "{0} App暂不支持IOS版本，敬请期待！",
    accountNumber: "账户号",
    downloadAppOnGP: "Google Play下载{0}应用",
    downloadAppOnAppStore: "App Store下载{0}应用",
    password: "密码",
    egateeWebsite: "Egatee 官方网站",
    suggestion: "建议",
    downloadBuyerApp: "下载Egatee App",
    aboutUs: "关于我们",
    downloadAPP: "下载{0} App",
    china: "中国",
    scanQrCode: "扫描二维码",
    CoteDivoire: "Côte d'Ivoire",
    uganda: "乌干达",
    goDownloadEgateeAPP: "去下载 Egatee App"
}